/*       */

import { gql } from '@apollo/client';

// Replaces the whole `llm` system-settings section. Pass the full providers list:
// { settings: { providers: [{ id, apiFormat, apiKey, baseUrl }] } }
export default gql`
    mutation updateLlmSettingsMutation($settings: JSON) {
        result: updateSystemSettings(section: llm, settings: $settings)
    }
`;
